module.exports = __webpack_public_path__ + "static/the-mind-parasites-a0b6715de260e931d66d76c0a282bb49.jpg";